export default "assets/images/logo-8f584244.svg";